// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-dialog-content {
   width: 380px
}

mat-form-field {
   display: block;
}

::ng-deep .mat-form-field {
   width: 320px
}

#forgot-form {
   position: relative;
   margin-bottom: -24px
}

.error {
   font-size: 13px;
}

::ng-deep .mat-button:hover .mat-button-focus-overlay {
   opacity: 0.04 !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/account/forgot-password/forgot-password.component.css"],"names":[],"mappings":"AAAA;GACG;AACH;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG;AACH;;AAEA;GACG,kBAAkB;GAClB;AACH;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,wBAAwB;AAC3B","sourcesContent":["mat-dialog-content {\n   width: 380px\n}\n\nmat-form-field {\n   display: block;\n}\n\n::ng-deep .mat-form-field {\n   width: 320px\n}\n\n#forgot-form {\n   position: relative;\n   margin-bottom: -24px\n}\n\n.error {\n   font-size: 13px;\n}\n\n::ng-deep .mat-button:hover .mat-button-focus-overlay {\n   opacity: 0.04 !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
